import axios from 'axios'
import store from '@/store'
async function getProviders(id = '') {
    try {
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/cnpj/provider/${id}/download`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        });

        return result.data.payload
    } catch (err) {
        console.log(err)
        if (err.data && err.data.message.name == 'TokenExpiredError') {
            return window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
    }
}

export default getProviders